/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEvacuationExpense32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M23 19.735h-3 3.891a3.723 3.723 0 00-.04-7.445c-.204.013-.316.014-.332.022v-.11C23.52 8.227 20.439 5 16.643 5c-2.681 0-5.005 1.61-6.14 3.956a.548.548 0 00-.09-.016 5.431 5.431 0 00-6.904 5.227c-.008.05-.008.1-.008.15a5.44 5.44 0 005.698 5.433c2.625-.006 5.18-.006 5.236-.015M9.938 26h1.375M7 26h1.376M11.313 23h1.5M8.438 23h1.5M5.5 23H7'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M14.037 15.485l-1.201 3.074 3.208 2.661L13.172 29a.17.17 0 00.293.164l6.937-8.755-2.21-2.526 2.152-3.875'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M8.922 14.899l1.442.677a5.04 5.04 0 006.338-1.773'
      />
    </svg>
  );
}

export default SvgEvacuationExpense32;
